import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import ExcludeFilter from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/ExcludeFilter";
import type { SuppressionList } from "app/pages/sales-intelligence/sub-modules/management/components/types";

export default class FindExcludeBySuppressionListFilter extends ExcludeFilter<
    readonly number[],
    readonly SuppressionList[]
> {
    constructor(deps: IFilterPanelBaseFilterDeps<readonly number[], readonly SuppressionList[]>) {
        super(deps);
    }

    getEmptyValue(): readonly number[] | undefined {
        return undefined;
    }

    isFilterDirty(currentValue: readonly number[] | undefined): boolean {
        if (!currentValue?.length) {
            return false;
        }
        return currentValue.length > 0;
    }

    getFullSelection(): readonly number[] | undefined {
        return this.options.map((c) => c.id);
    }
}
